import { IChatbotConfig } from '../interface/IChatbot';
import { CHATBOT_API_DOMAIN, CHATBOT_DOMAIN } from '../common/Const';
import {checkIsPurple, makeEl} from '../common/Utils';
import axios from 'axios';
import { checkIsCommunitySdk } from '../common/Utils';

export default class Index {
  private apiUrl = CHATBOT_API_DOMAIN['sb'];
  private chatBotUrl = CHATBOT_DOMAIN['sb'];
  private service = '';
  private newIcon: HTMLElement | null = null;

  constructor(_config: IChatbotConfig) {
    if( checkIsCommunitySdk() || checkIsPurple()) return;
    this.apiUrl = CHATBOT_API_DOMAIN[_config.serviceEnv.toLowerCase()];
    this.chatBotUrl = CHATBOT_DOMAIN[_config.serviceEnv.toLowerCase()];
    this.service = _config.service;
    this.addButtonTempl();
    this.checkUserLogin();
  }
  //템플릿 그려주기
  private addButtonTempl() {
    const body = document.body;
    const container = makeEl('button', body, {
      class: 'ncui-chatbot',
    });
    container.addEventListener('click', this.openChatbot.bind(this));
    makeEl('div', container, {
      class: 'ncui-chatbot__bg',
    });
    this.newIcon = makeEl('div', container, {
      class: 'ncui-chatbot__icon',
    });
  }

  private openChatbot() {
    const width = 744;
    const height = 850;
    const left = Math.ceil((window.screen.width - width) / 2);
    const top = Math.ceil((window.screen.height - height) / 2);
    const serviceURL = this.service == 'bnsneo' ? '/select/bns' : this.service;
    window.open(
      `${this.chatBotUrl}/${serviceURL}`,
      '_blank',
      `width=${width}, height=${height}, left=${left}, top=${top}`
    );
  }

  //로그인 여부 체크 userData?
  private checkUserLogin() {
    window.userData.isLogin ? this.getChatUnread() : null;
  }
  private async getChatUnread() {
    //console.log('/nccb/v1.0/chat/message/unread api 호출');
    try {
      const { data } = await axios({
        method: 'get',
        responseType: 'json',
        url: `${this.apiUrl}/nccb/v1.0/chat/message/unread`,
        withCredentials: true,
      });
      data.result
        ? this.newIcon?.classList.add('ncui-chatbot__icon--active')
        : this.newIcon?.classList.remove('ncui-chatbot__icon--active');
    } catch (err) {
      console.log('error (/nccb/v1.0/chat/message/unread) : ', err);
      throw err;
    }
  }

  //로그인시 api 호출 ( 타이머 설정? )

  //비로그인시 새창 열린후 로그인 처리되면 새로고침
}
